import type React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@roger/ui-components';
import { UserLicensesSection } from '../UserLicensesSection';
import type { OrgMemberResponse } from '../types';
import { memberDisplayName } from './clinicSetup';

/** One member's licenses, edited in place, opened from the Licenses cell. */
export const MemberLicensesDialog: React.FC<{
  member: OrgMemberResponse & { roger_user_id: string };
  canEdit: boolean;
  onClose: () => void;
  onCloseAutoFocus: (event: Event) => void;
}> = ({ member, canEdit, onClose, onCloseAutoFocus }) => (
  <Dialog open onOpenChange={open => !open && onClose()}>
    <DialogContent
      className='flex max-h-[80vh] flex-col sm:max-w-3xl'
      onCloseAutoFocus={onCloseAutoFocus}
    >
      <DialogHeader>
        <DialogTitle>{memberDisplayName(member)}</DialogTitle>
      </DialogHeader>
      <div className='-mr-2 min-h-0 flex-1 overflow-y-auto pr-2'>
        <UserLicensesSection
          userId={member.roger_user_id}
          canEdit={canEdit}
          collapsible={false}
          inDialog
        />
      </div>
    </DialogContent>
  </Dialog>
);
